var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBranches2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.91016 6.48348V14.5918C1.91016 16.1751 3.03516 16.8251 4.40182 16.0418L6.36016 14.9251C6.78516 14.6835 7.49349 14.6585 7.93516 14.8835L12.3102 17.0751C12.7518 17.2918 13.4602 17.2751 13.8852 17.0335L17.4935 14.9668C17.9518 14.7001 18.3352 14.0501 18.3352 13.5168V5.40848C18.3352 3.82514 17.2102 3.17514 15.8435 3.95848L13.8852 5.07514C13.4602 5.31681 12.7518 5.34181 12.3102 5.11681L7.93516 2.93348C7.49349 2.71681 6.78516 2.73348 6.36016 2.97514L2.75182 5.04181C2.28516 5.30848 1.91016 5.95848 1.91016 6.48348Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13281 3.3335V14.1668",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1094 5.5166V16.6666",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranches2);
export default __webpack_public_path__ + "static/media/branches2.3a59fa781f28c1a124ad183213cd19f2.svg";
export { ForwardRef as ReactComponent };